import api from '@/utils/api';

/**
 * Get  supplier's product categories
 * @param {string} id - the supplier id
 * @returns {Promise}
 */
const getSupplierProductCategoriesApi = (id) => {
  const url = `/dealer/${id}/product-category/`;
  return api.get(url);
};

export default getSupplierProductCategoriesApi;
